import React, { useContext, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
// Si vas a implementar el modal de edición, importalo acá
// import ModalEditarEmpleado from "./ModalEditarEmpleado";

const ItemTablaEmpleadosInternos = ({ empleado, index, onActualizarDatos }) => {
    const { darkMode } = useContext(DarkModeContext);
    const [modalShow, setModalShow] = useState(false);

    return (
        <>
            <tr className={darkMode ? "tabla-borde-bottom text-white" : "tabla-borde-bottom text-dark"}>
                <td className="fs-12-a-10 lato-regular pt-4">{index}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.legajo}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.razonSocial}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.estado}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.apellido}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.nombre}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.dni}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.cuil}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.domicilio}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.ciudad}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.provincia}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.codigoPostal}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.fechaNacimiento}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.celular}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.email}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.estadoCivil}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.emergencia}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.hijosDep}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.parentesco1}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.parentesco2}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.parentesco3}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.parentesco4}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.parentesco5}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.secundarios}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.terciariosUniv}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.posgrado}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.fechaIngreso}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.area}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.puesto}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.horarioLaboral}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.cbu}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.alias}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.banco}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.pdfCbu}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.validado}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.correosCorp}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.modalidad}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.tipoServicio}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.fechaAlta}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.hsTrabajo}</td>
                <td className="fs-12-a-10 lato-regular pt-4">{empleado.fechaBaja}</td>
                <td className="fs-13 lato-regular d-flex margin-left-btn-publicar">
                    <div className="margin-left-right-btn-publicar">
                        <div className="d-flex centrado-responsive">
                            <Button
                                className="btn-publicar centrado border-0 mx-2"
                                onClick={() => setModalShow(true)}
                            >
                                <FontAwesomeIcon className="text-dark fs-16-a-14" icon={faPen} />
                            </Button>
                        </div>
                        {/* 
                        <ModalEditarEmpleado
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            empleado={empleado}
                            onActualizarDatos={onActualizarDatos}
                        /> 
                        */}
                    </div>
                </td>
            </tr>
        </>
    );
};

export default ItemTablaEmpleadosInternos;
